import { findLast } from "lodash-es";
import { SessionPartKind, ReasoningV1SessionPart } from "@/mds/components/sessions/session.types";
import {
  SESSION_THOUGHT_PROCESS_TEXTS,
  SESSION_TEXT_DISPLAY_CONFIG,
} from "./reasoning-group.constants";
import { SessionItem } from "@/mds/components/sessions/session-item/session-item.utils";

/**
 * Truncates text if it exceeds the maximum length, adding an ellipsis
 */
function truncateTextIfNeeded({ text }: { text: string }): string {
  if (text.length <= SESSION_TEXT_DISPLAY_CONFIG.MAX_HEADER_LENGTH) {
    return text;
  }

  const endIndex =
    SESSION_TEXT_DISPLAY_CONFIG.MAX_HEADER_LENGTH - SESSION_TEXT_DISPLAY_CONFIG.TRUNCATION_BUFFER;
  const truncatedText = text.substring(0, endIndex);
  return `${truncatedText}${SESSION_TEXT_DISPLAY_CONFIG.TRUNCATION_SUFFIX}`;
}

/**
 * Extracts the first line from text content and cleans it up
 */
function extractFirstLine({ content }: { content: string }): string {
  const lines = content.split("\n");
  const firstLine = lines[0].trim();
  return firstLine;
}

/**
 * Extracts the latest thinking text from the reasoning parts.
 * This looks at the most recent reasoning part and displays its summary
 * as the current thinking status.
 */
export function extractLatestThinkingTextFromSessionItem({ item }: { item: SessionItem }): string {
  const parts = item.data.map(data => data.part);

  if (parts.length === 0) {
    return SESSION_THOUGHT_PROCESS_TEXTS.THINKING;
  }

  const mostRecentReasoningPart = findLast(
    parts,
    part => part.kind === SessionPartKind.ReasoningV1
  );

  if (!mostRecentReasoningPart) {
    return SESSION_THOUGHT_PROCESS_TEXTS.PROCESSING;
  }

  const reasoningPart = mostRecentReasoningPart as ReasoningV1SessionPart;
  const firstLine = extractFirstLine({ content: reasoningPart.summary });

  if (!firstLine) {
    return SESSION_THOUGHT_PROCESS_TEXTS.PROCESSING;
  }

  return truncateTextIfNeeded({ text: firstLine });
}
